export default __webpack_public_path__ + "static/media/Norway.9aabd635.svg";